"use client"

import { Popover as PopoverPrimitive } from "@base-ui/react/popover"
import { cn } from "../../lib/utils"
import { useCogoPortalContainer } from "../../core/render-context"

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

function PopoverContent({
  className,
  align = "center",
  sideOffset = 4,
  ...props
}: PopoverPrimitive.Popup.Props &
  Pick<PopoverPrimitive.Positioner.Props, "align" | "sideOffset">) {
  const portalContainer = useCogoPortalContainer()
  return (
    <PopoverPrimitive.Portal container={portalContainer ?? undefined}>
      <PopoverPrimitive.Positioner
        align={align}
        sideOffset={sideOffset}
        className="isolate z-50"
      >
        <PopoverPrimitive.Popup
          data-slot="popover-content"
          // Style-scoped CSS (.style-luma .cn-popover-content { ... }) doesn't
          // reach the portaled popover when style class isn't on document.html.
          // Apply DS surface utilities inline so popover always has the right
          // bg / border / shadow / radius regardless of style scope. The
          // cn-popover-content* classes remain so theme-specific overrides
          // (animations, side translations) still win when scoped.
          className={cn(
            "cn-popover-content cn-popover-content-logical w-72 outline-none",
            "bg-popover text-popover-foreground border border-border rounded-md shadow-md p-4",
            className,
          )}
          {...props}
        />
      </PopoverPrimitive.Positioner>
    </PopoverPrimitive.Portal>
  )
}

export { Popover, PopoverTrigger, PopoverContent }
